import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ChangePasswordComponent } from 'taxilla-library';

@Component({
    selector: 'app-passwordexpire',
    templateUrl: './passwordexpire.component.html',
    styleUrls: ['./passwordexpire.component.scss'],
    standalone: false,
})
export class PasswordexpireComponent implements OnInit {
    passwordExpiryDate: any;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog) {}

    closeModal = () => {
        this.dialog.closeAll();
    };

    openChangePasswordModal = () => {
        this.dialog.open(ChangePasswordComponent, {
            panelClass: ['changePasswordModal', 'matDialogContainer', 'w-50'],
            disableClose: true,
        });
    };

    ngOnInit(): void {}
}
